module.exports = __webpack_public_path__ + "05_medium_gold.d393ff1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/05_medium_gold.png
// module id = zhSO
// module chunks = 0